import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#1976d2" : "#1976d2")};
  background-color: ${(props) => (props.border ? "white" : "#1976d2")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#1976d2" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "white" : "#1976d2")};
    border: 1px solid #1976d2;
    color: ${(props) => (props.border ? "#1976d2" : "#fff")};
  }
`;

